<template>
  <div class="form-popin-auto-complete">
    <input type="text"
      :value="locationText"
      @input="(e) => { onChangeValueInputWhere(e) }"
      @focus="displayListLocations = true, $emit('onFocusSearch')"
      @keyup="displayListLocations = true;locationInput()"
      ref="locationInputRef"
      @focusout="focusOutLocationInput()"
      @keyup.down="whereCursorIndex = newCursorWhereIndex(whereCursorIndex, 'down');"
      @keyup.up="whereCursorIndex = newCursorWhereIndex(whereCursorIndex, 'up');"
      @keyup.esc="locationText = '';  displayListLocations = false;"
      @keyup.end="hasWhereCursor = false; whereCursorIndex = -1"
      v-on:keyup.enter="hasWhereCursor = onEnterWhereInput(whereCursorIndex)"
      class="input-where"
      :placeholder="placeholder"
      aria-label="Précisez votre ville" />
    <div class="iframe-covid-list-btns">
      <button v-if="locationText" @click="clearWhere()" type="button" class="clear-item-search btn-close">
        <i class="icon-close-circle-solid" aria-hidden="true"></i>
        <span class="sr-only">Supprimer</span>
      </button>
      <button
        class="iframe-covid__btn-search iframe-covid-btn"
        type="button"
        aria-label="Rechercher"
        :disabled='locationText?.length < 3'
        @click.prevent="onClickSearchButton"
      >
        <i class="icon-search" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <WhereAutoComplete
    class="iframe-covid__where-input"
    :cursorIndex="whereCursorIndex"
    :displayListLocations="displayListLocations"
    :isAbsolute="false"
    :locationListApi="locationListApi"
    :locationListHistoyFiltred="locationListHistoyFiltred"
    :no-result="noResult"
    @onClearLocationHistory="$emit('onClearLocationHistory')"
    @onClickLocationText="onClickLocationText"
    @onRemoveLocationItem="$emit('onRemoveLocationItem', $event)"
  />
</template>

<script>
import { ref, computed, watch } from 'vue';
import WhereAutoComplete from '@/components/homePage/autoCompleteComponents/WhereAutoComplete.component.vue';
import { debounce, htmlStripper } from '@/helpers';
import iframeCovidService from '@/services/iframeCovid';

export default {
  components: {
    WhereAutoComplete,
  },
  props: {
    locationListApi: {
      type: Array,
      default: () => [],
    },
    locationListHistory: {
      type: Array,
      default: () => [],
    },
    resetAction: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'onFocusSearch',
    'onSearch',
    'onLocationinput',
    'clearWhere',
    'onRemoveLocationItem',
    'onClearLocationHistory',
  ],
  setup(props, { emit }) {
    const displayListLocations = ref(false);
    const hasWhereCursor = ref(false);
    const locationInputRef = ref('');
    const locationText = ref('');
    const noResult = ref(false);
    const searchBtnRef = ref('');
    const whereCursorIndex = ref(-1);
    const whereValue = ref('vide');
    const focusOutInput = debounce(() => { displayListLocations.value = false; });
    const focusOutLocationInput = debounce(() => { displayListLocations.value = false; });
    const locationInput = debounce(() => {
      emit(
        'onLocationinput',
        locationText.value.length > 2 ? locationText.value : null,
      );
    });
    const placeholder = iframeCovidService.getPlaceholder();
    const locationListHistoyFiltred = computed(() => (locationText.value.length > 2 ? [] : props.locationListHistory));
    watch(() => props.locationListApi, (locationListApi) => {
      noResult.value = !locationListApi.length && locationText.value.length > 2;
    });

    watch(() => props.resetAction, (resetAction) => {
      if (resetAction) {
        locationText.value = '';
        noResult.value = false;
        whereValue.value = 'vide';
      }
    });

    function search() {
      whereValue.value = 'vide';
      emit('onSearch', { locationText: whereValue.value });
    }
    function clearWhere() {
      locationText.value = '';
      noResult.value = false;
      whereValue.value = 'vide';
      emit('clearWhere');
    }
    function newCursorWhereIndex(index, event) {
      const totalDisplayedElements = (props.locationListApi.slice(0, 5).length) + (locationListHistoyFiltred.value.slice(0, 3).length);
      if (event === 'down') {
        return (index < totalDisplayedElements) ? (index + 1) : 0;
      }
      hasWhereCursor.value = true;
      return (index > 0) ? (index - 1) : totalDisplayedElements;
    }

    function onChangeValueInputWhere(e) {
      locationText.value = e.target.value;
    }

    function onEnterWhereInput(index) {
      if (whereCursorIndex.value === -1) {
        search();
      } else if (index === (props.locationListApi || []).length) {
        locationText.value = 'Autour de moi';
      } else {
        locationText.value = htmlStripper(props.locationListApi[index] || locationListHistoyFiltred.value?.[index - 1]);
        whereValue.value = locationText.value;
        emit('onSearch', { locationText: whereValue.value });
      }
      whereCursorIndex.value = -1;
      displayListLocations.value = false;
      return false;
    }

    function handleSubmit() {
      emit('onSearch', { locationText: locationText.value });
    }

    const onClickLocationText = (event) => {
      locationText.value = event;
      whereValue.value = event;
      emit('onSearch', { locationText: event });
    };

    const onClickSearchButton = () => {
      emit('onSearch', { locationText: whereValue.value });
    };

    return {
      locationText,
      displayListLocations,
      locationInput,
      focusOutLocationInput,
      placeholder,
      locationListHistoyFiltred,
      hasWhereCursor,
      clearWhere,
      focusOutInput,
      locationInputRef,
      searchBtnRef,
      whereCursorIndex,
      newCursorWhereIndex,
      onChangeValueInputWhere,
      onEnterWhereInput,
      onClickLocationText,
      onClickSearchButton,
      handleSubmit,
      noResult,
      whereValue,
    };
  },
};
</script>
